import React, { memo } from 'react'
import { Box } from '@mui/material'
import { SuperChartConfiguration_DateRange } from '../../proto/generated/superchart-page'
import { Security } from '../../proto/generated/security'
import OverviewChartPanel from './OverviewChartPanel'
import { overviewDateRangeKey } from './overviewChartProps'

export type OverviewChartSlotProps = {
    security: Security
    dateRange?: SuperChartConfiguration_DateRange
}

const OverviewChartSlot = ({ security, dateRange }: OverviewChartSlotProps) => (
    <Box sx={{ height: '100%', width: '100%' }}>
        <OverviewChartPanel security={security} dateRange={dateRange} />
    </Box>
)

const overviewChartSlotPropsAreEqual = (prev: OverviewChartSlotProps, next: OverviewChartSlotProps) =>
    prev.security.exchange === next.security.exchange &&
    prev.security.code === next.security.code &&
    overviewDateRangeKey(prev.dateRange) === overviewDateRangeKey(next.dateRange)

export default memo(OverviewChartSlot, overviewChartSlotPropsAreEqual)
